/* TE Fotogalerij v3: tabs, animaties bij scrollen, lightbox (okt 2026) */
(function(){
  function init(root){
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    root.classList.add('te-g--js');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = null;
    if ('IntersectionObserver' in window && !reduce) {
      io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    }
    function reveal(scope, reset){
      scope.querySelectorAll('.te-rv, .te-rl').forEach(function(el){
        if (!io) { el.classList.add('is-in'); return; }
        if (reset) el.classList.remove('is-in');
        io.observe(el);
      });
    }
    var hero = root.querySelector('.te-g-hero');
    if (hero) reveal(hero);

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.te-g-tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.te-g-panel'));
    var bar = root.querySelector('.te-g-tabs');
    var current = null;

    function activate(id, opts){
      opts = opts || {};
      var target = null;
      panels.forEach(function(p){ if (p.id === id) target = p; });
      if (!target) return;
      tabs.forEach(function(t){
        var on = t.getAttribute('aria-controls') === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('is-active', on);
        if (on) {
          if (opts.focus) t.focus({ preventScroll: true });
          if (bar && bar.scrollWidth > bar.clientWidth) {
            bar.scrollTo({ left: t.offsetLeft - (bar.clientWidth - t.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
          }
        }
      });
      panels.forEach(function(p){ p.hidden = (p !== target); });
      if (current !== target) {
        target.classList.remove('is-shown');
        void target.offsetWidth;
        target.classList.add('is-shown');
        reveal(target, true);
      }
      current = target;
      if (opts.hash && window.history && history.replaceState) history.replaceState(null, '', '#' + id);
    }

    tabs.forEach(function(t, i){
      t.addEventListener('click', function(e){ e.preventDefault(); activate(t.getAttribute('aria-controls'), { hash: true }); });
      t.addEventListener('keydown', function(e){
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') n = tabs[0];
        else if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); activate(n.getAttribute('aria-controls'), { focus: true, hash: true }); }
      });
    });

    var start = panels.length ? panels[0].id : null;
    var hash = decodeURIComponent((location.hash || '').slice(1));
    if (hash && panels.some(function(p){ return p.id === hash; })) start = hash;
    if (start) activate(start);

    root.querySelectorAll('.te-g-more').forEach(function(btn){
      btn.addEventListener('click', function(){
        var p = btn.closest('.te-g-panel');
        var open = p.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
        if (!open) btn.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    var lb = root.querySelector('[data-lb-root]');
    if (!lb) return;
    var lbImg = lb.querySelector('.te-lb__img');
    var lbT = lb.querySelector('.te-lb__t');
    var lbS = lb.querySelector('.te-lb__s');
    var lbC = lb.querySelector('.te-lb__count');
    var lbClose = lb.querySelector('.te-lb__close');
    var list = [], idx = 0, lastFocus = null, closeTimer = null;

    function show(i){
      if (!list.length) return;
      idx = (i + list.length) % list.length;
      var it = list[idx];
      var src = it.getAttribute('data-full');
      lbImg.classList.remove('is-ready');
      var pre = new Image();
      pre.onload = pre.onerror = function(){
        if (list[idx] !== it) return;
        lbImg.src = src;
        lbImg.alt = it.getAttribute('data-alt') || '';
        requestAnimationFrame(function(){ lbImg.classList.add('is-ready'); });
      };
      pre.src = src;
      lbT.textContent = it.getAttribute('data-t') || '';
      lbS.textContent = it.getAttribute('data-s') || '';
      lbC.textContent = (idx + 1) + ' / ' + list.length;
      [1, -1].forEach(function(d){
        var n = list[(idx + d + list.length) % list.length];
        if (n && n !== it) { var x = new Image(); x.src = n.getAttribute('data-full'); }
      });
    }
    function openLb(btn){
      var scope = btn.closest('.te-g-panel') || root;
      list = Array.prototype.slice.call(scope.querySelectorAll('[data-lb="' + btn.getAttribute('data-lb') + '"]'));
      lastFocus = btn;
      clearTimeout(closeTimer);
      lb.hidden = false;
      document.documentElement.classList.add('te-lb-lock');
      requestAnimationFrame(function(){ lb.classList.add('is-open'); });
      show(Math.max(0, list.indexOf(btn)));
      lbClose.focus({ preventScroll: true });
    }
    function closeLb(){
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('te-lb-lock');
      closeTimer = setTimeout(function(){ lb.hidden = true; lbImg.removeAttribute('src'); lbImg.classList.remove('is-ready'); }, reduce ? 0 : 400);
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    }
    root.addEventListener('click', function(e){
      var b = e.target.closest('[data-lb]');
      if (b && !lb.contains(b)) { e.preventDefault(); openLb(b); }
    });
    lbClose.addEventListener('click', closeLb);
    lb.querySelector('.te-lb__prev').addEventListener('click', function(){ show(idx - 1); });
    lb.querySelector('.te-lb__next').addEventListener('click', function(){ show(idx + 1); });
    lb.addEventListener('click', function(e){
      if (e.target === lb || e.target.classList.contains('te-lb__fig')) closeLb();
    });
    document.addEventListener('keydown', function(e){
      if (lb.hidden || !document.body.contains(lb)) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'Tab') {
        var f = Array.prototype.slice.call(lb.querySelectorAll('button'));
        var a = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(a + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    });
    var sx = 0, sy = 0;
    lb.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    lb.addEventListener('touchend', function(e){
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? idx + 1 : idx - 1);
      else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) closeLb();
    }, { passive: true });

    document.addEventListener('shopify:block:select', function(e){
      var el = e.target;
      if (!root.contains(el)) return;
      var p = el.closest('.te-g-panel');
      if (!p) return;
      activate(p.id);
      if (el.classList.contains('is-extra')) {
        p.classList.add('is-expanded');
        var mb = p.querySelector('.te-g-more');
        if (mb) { mb.setAttribute('aria-expanded', 'true'); mb.textContent = mb.getAttribute('data-less'); }
      }
      el.classList.add('is-in');
    });
  }
  function boot(scope){
    (scope || document).querySelectorAll('.te-g').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();